import { render, staticRenderFns } from "./VisualizarHistoricoDeFormacaoDialog.vue?vue&type=template&id=7d49f4ce&scoped=true"
import script from "./VisualizarHistoricoDeFormacaoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarHistoricoDeFormacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarHistoricoDeFormacaoDialog.vue?vue&type=style&index=0&id=7d49f4ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49f4ce",
  null
  
)

export default component.exports